<template>
    <div class="w-full border-b border-blue-300 bg-blue-200 text-blue-800 text-left md:text-center leading-snug py-2 px-6 text-sm md:text-base">
        <div v-if="invitations_to_view" class="my-3">
            <i class="text-blue-700 fa fa-bell text-sm mr-2"></i> {{ invitations_to_view == 1 ? 'A user is' : invitations_to_view + ' users are' }} inviting you to view their account. Visit <a class="font-bold text-blue-700 hover:text-gray-800" href="/broker/settings/shared-accounts">Shared Account Settings</a> to accept or reject the invitation.
        </div class="my-3">

        <div v-if="reqests_for_access" class="my-3">
            <i class="text-blue-700 fa fa-bell text-sm mr-2"></i> {{ reqests_for_access == 1 ? 'A user is' : reqests_for_access + ' users are' }}  requesting access to view your account. Visit <a class="font-bold text-blue-700 hover:text-gray-800" href="/broker/settings/shared-accounts">Shared Account Settings</a> to accept or reject the request.
        </div class="my-3">
    </div>
</template>

<script>
export default {
    props: {
        invitations_to_view: {},
        reqests_for_access: {}
    },
}
</script>
